var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubmit({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.125 8.0555V17.6255C4.125 19.5855 6.25499 20.8155 7.95499 19.8355L12.105 17.4455L16.255 15.0455C17.955 14.0655 17.955 11.6155 16.255 10.6355L12.105 8.23549L7.95499 5.84551C6.25499 4.86551 4.125 6.0855 4.125 8.0555Z",
    fill: "#47CD89"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6094 19.7662C20.1994 19.7662 19.8594 19.4262 19.8594 19.0162V6.65625C19.8594 6.24625 20.1994 5.90625 20.6094 5.90625C21.0194 5.90625 21.3594 6.24625 21.3594 6.65625V19.0162C21.3594 19.4262 21.0294 19.7662 20.6094 19.7662Z",
    fill: "#47CD89"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubmit);
export default __webpack_public_path__ + "static/media/submit.b3827cc1e579a7100d8c0903c7544093.svg";
export { ForwardRef as ReactComponent };